// import { getCurrentUser } from "../auth";
import * as actions from "./actions";

import instance from "../axios";
import { setPrizes } from "services/quiz/actions";

export const setUser = (payload: any) => {
  return (dispatch: any) => {
    if (payload) {
      dispatch(actions.setCurrentUser(payload));
      dispatch(setPrizes(payload.assignedPrizes));
    }
  };
};

// // Using this on dashboard page load causes a bug on ANdroid devices which led to a the user being cyclical prompted to download the previous quiz.
export const syncUser = (id: number) => {
  return (dispatch: any) => {
    return instance
      .get(`v1/customer/${id}?ts=${new Date().getTime()}`)
      .then((res) => {
        alert(res.data.availableQuizId);
        console.log(res.data);
        dispatch(actions.updateCurrentUser(res.data));
        dispatch(setPrizes(res.data.assignedPrizes));
        return res;
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

// export const checkLoggedIn = () => {
//   console.log("checking logged in");
//   return (dispatch: any) => {
//     console.log("checking logged in dispatch");
//     getCurrentUser().then((user) => {
//       console.log(user);
//       if (user) {
//         dispatch(actions.setLoggedIn(true));
//       } else {
//         dispatch(actions.setLoggedIn(false));
//       }
//     });
//   };
// };

export const logoutUser = () => {
  return (dispatch: any) => {
    dispatch(actions.logUserOut());
  };
};

export const logoutWithoutLastUser = () => {
  return (dispatch: any) => {
    dispatch(actions.logoutWithoutLastUser());
  };
};

export const newUserReset = () => {
  return (dispatch: any) => {
    dispatch(actions.newUserReset());
  };
};
